import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryDesignFont extends TraitRegistryCategory {
    label = 'Schriftart';
    constructor(parent) {
        super(parent);
        super.init();
    }
    designTextShadow = () => new TraitTypeSelectWithPreview({
        default: '',
        stylesheet: () => '/lib/cssStyles/textshadow.css' /*
      label: 'Textschatten Vorlage',
      select: [
        'textShadow_elegantshadow',
        'textShadow_deepshadow',
        'textShadow_insetshadow',
        'textShadow_retroshadow'
      ].map(k => [k]) as [string][], */,
        classNames: ({ at }) => [at.trait.value],
    });
    googleFont = () => new TraitTypeSelectWithPreview({
        default: 'sans-serif',
        css: ({ at }) => {
            const cssPairs = [];
            cssPairs.push({ k: 'fontFamily', v: `'${at.trait.value}', sans-serif` });
            if (at.activeOf.fontWeight) {
                cssPairs.push({ k: 'fontWeight', v: at.valueOf.fontWeight });
            }
            if (at.activeOf.fontWeight) {
                cssPairs.push({ k: 'fontStyle', v: at.valueOf.fontStyle });
            }
            if (at.activeOf.textShadow) {
                cssPairs.push(...at.activeOf.textShadow.attachedCss.cssPairs);
            }
            return cssPairs;
        },
        classNames: ({ at }) => {
            if (at.activeOf.googleFontEffect) {
                return at.valuesOf.googleFontEffect.map(v => `font-effect-${v}`);
            }
            return [];
        },
        stylesheet: ({ at }) => {
            let url = `https://fonts.googleapis.com/css?family=${at.trait.value}&display=swap`;
            if (at.activeOf.fontWeight || at.activeOf.fontStyle) {
                url = `${url}:`;
            }
            if (at.activeOf.fontWeight) {
                url = url + at.valueOf.fontWeight;
            }
            if (at.activeOf.fontStyle) {
                url = `${url}i`;
            }
            if (at.activeOf.googleFontEffect) {
                url = `${url}&effect=${at.valuesOf.googleFontEffect.join('|')}`;
            }
            return url;
        },
    });
    googleFontEffect = () => new TraitTypeSelectWithPreview({
        hidden: true,
        multiple: true /*
        init: 'outline',
        label: 'Google Font Effect',
        select: [
          ['outline'],
          ['shadow-multiple'],
          ['3d'],
          ['3d-float'],
          ['emboss'],
          ['fire'],
          ['fire-animation'],
          ['anaglyph']
        ] */,
    });
}
